import {Component, OnInit, Input, Output, EventEmitter, OnChanges, SimpleChanges, ViewChild, Type, ElementRef, Renderer2} from '@angular/core';
import * as $ from 'jquery';
import 'select2';
import 'jquery-jcrop';
import { Store } from '@ngrx/store';
import { HttpService } from '../../service/http.service';
import {Bounds, CropperSettings, ImageCropperComponent} from "ng2-img-cropper-mm420";
import * as _ from 'lodash';
import {environment} from "../../../environments/environment";
import { eventEmitterService } from '../../service/eventEmitter.service';

@Component({
  selector: 'app-image-upload',
  templateUrl: './image-upload.component.html',
  styleUrls: ['./image-upload.component.css']
})
export class ImageUploadComponent implements OnInit, OnChanges{
  //Cropper 1 data
  data1:any;
  cropperSettings:CropperSettings;

  //Cropper 2 data
  data2:any;
  cropperSettings2:CropperSettings;
  @ViewChild('cropper', undefined) cropper:ImageCropperComponent;

  @ViewChild('cropper', undefined) cropper2:ImageCropperComponent;

  @Input('source') source;
  @Input('src') imgSrc;
  @Input() nested: boolean = false;

  @Output('imageSourceEmitter')
  imageSourceEmitter:EventEmitter<any> = new EventEmitter();

  cropHeader;
  canvasShow = true;
  apiUrl = environment.apiUrl;

  /**
   * Set all config parameters for the image cropper
   * @param {HttpService} _http
   * @param {Store<any>} store
   */
  constructor(private _http:HttpService, private store:Store<any>,
    private eventService : eventEmitterService, private el: ElementRef, private renderer: Renderer2) {
    //super();
    this.cropperSettings = new CropperSettings();
    this.cropperSettings.width = 200;
    this.cropperSettings.height = 200;
    this.cropperSettings.croppedWidth = 300;
    this.cropperSettings.croppedHeight = 225;
    this.cropperSettings.canvasWidth = 570;
    this.cropperSettings.canvasHeight = 300;
    this.cropperSettings.minWidth = 100;
    this.cropperSettings.minHeight = 100;
    this.cropperSettings.rounded = true;
    this.cropperSettings.cropperDrawSettings.strokeColor = 'rgba(200,60,60,1)';
    this.cropperSettings.cropperDrawSettings.strokeWidth = 2;

    // if ($(window).innerWidth() < 768) {
    //   this.cropperSettings.canvasWidth = ($(window).innerWidth() - 50);
    //   this.cropperSettings.canvasHeight = (($(window).innerWidth() -50)/1.9);
    // }
    // if ($(window).innerWidth() < 480){
    //   this.cropperSettings.canvasWidth = ($(window).innerWidth() - 50);
    //   this.cropperSettings.canvasHeight = (($(window).innerWidth() - 50));
    // }

    this.data1 = {};

    //Cropper settings 2
    this.cropperSettings2 = new CropperSettings();
    this.cropperSettings2.width = 200;
    this.cropperSettings2.height = 200;
    this.cropperSettings2.keepAspect = false;

    this.cropperSettings2.croppedWidth = 200;
    this.cropperSettings2.croppedHeight = 200;

    this.cropperSettings2.canvasWidth = 500;
    this.cropperSettings2.canvasHeight = 300;

    this.cropperSettings2.minWidth = 100;
    this.cropperSettings2.minHeight = 100;

    this.cropperSettings2.rounded = true;
    this.cropperSettings2.minWithRelativeToResolution = false;

    this.cropperSettings2.cropperDrawSettings.strokeColor = 'rgba(255,255,255,1)';
    this.cropperSettings2.cropperDrawSettings.strokeWidth = 2;
    this.cropperSettings2.noFileInput = true;

    this.data2 = {};
  }

  ngOnChanges(changes: SimpleChanges) {
    if(this.imgSrc && this.imgSrc.split('assets')[1]){
      this.imgSrc = this.apiUrl + this.imgSrc.replace('assets/', '');
    }
  }

  ngOnInit() {
    this.eventService.eventEmit$.subscribe((data)=>{
      if (data.modalClose){
        setTimeout(() => {
          this.canvasShow = false;
        }, 100);
      }
      if (data.modalOpen){
          this.canvasShow = true;
      }
    })
    // $('.ng2-imgcrop input').addClass('ng2Input');
    this.eventService.eventEmit$
    .subscribe(popup => {
        //If user click New Message button from Message header component,
        //Here listening that evet to show new message user search section
        if(popup.openGroupPopup){
            this.imgSrc = null;
            this.data1 = {};
            // $('#img_upload_modal img-cropper span input[type="file"]').val('');
          }
    });
    // $(document).on('click', function (event) {
      // if ((!$(event.currentTarget).closest('.modal-dialog').length) && ($(event.currentTarget).closest('#img_upload_modal').length)) {
      //   $('#img_upload_modal .close').trigger('click');
      // }
    // });

    // Based on the this.source value, change the header title for the upload image popup box
    switch(this.source) {
      case 'building' :
        this.cropHeader = 'Upload your building image';
          // $('span.result').removeClass('profile_bg');
          // $('span.result').removeClass('group_bg');
         break;
      case 'user' :
        this.cropHeader = 'Upload your profile image';
        // $('span.result').addClass('profile_bg');
        // $('span.result').removeClass('group_bg');
         break;
      case 'group' :

        this.cropHeader = 'Upload your group image';
        // $('span.result').removeClass('profile_bg');
        // $('span.result').addClass('group_bg');
        break;
    }
  }
  closeCropper() {
    const modal = document.getElementById('img_upload_modal');
    if (modal) {
      (modal as any).style.display = 'none';
    }

    const backdrops = document.getElementsByClassName('modal-backdrop');
    if (backdrops.length > 0) {
      backdrops[backdrops.length - 1].parentNode.removeChild(backdrops[backdrops.length - 1]);
    }

    if (!this.nested && backdrops.length === 0 && document.body.classList.contains('modal-open')) {
      document.body.classList.remove('modal-open');
    }
  }

    public cropped(bounds:Bounds) {

    console.log(bounds);
  }

  /**
   * Save the cropped Image data based on this.source value
   * this.source can be building, group or user based on which corresponding localStorage value is set
   * @param fileData
   */
  saveFileData(fileData){
    console.log('::data',fileData)
    if(fileData !== undefined){
      this.imageSourceEmitter.emit(fileData);
      this.imgSrc = fileData;

      switch(this.source) {
        case 'building' :
          localStorage.setItem('buildingImage', fileData);
          sessionStorage.setItem('buildingImage', fileData);
          this.data1.image = null;
          break;
        case 'user' :
          sessionStorage.setItem('userImage',fileData ); break;
        case 'group' :
          sessionStorage.setItem('groupImage',fileData ); this.data1.image = null; break;
      }
      this.closeCropper();
    }
  }
 }
